import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import useAuth from '../../pages/useAuth';
import AttendanceCard from '../../components/AttendanceCards';

const BM_Dashboard = () => {
     useAuth();
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [attendanceData, setAttendanceData] = useState(null);
     useEffect(() => {
          const fetchAttendance = async () => {
               try {

                    const response = await fetch(`${baseUrl}/getUserAttendance`, {
                         method: "GET",
                         headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${sessionStorage.getItem("token")}`
                         },
                    });

                    const data = await response.json();
                    if (data.status) {
                         setAttendanceData(data.data);
                    }
               } catch (error) {
                    console.error("Error fetching attendance:", error);
               } finally {

               }
          };

          fetchAttendance();
     }, [baseUrl]);
     const todayPunchIn = attendanceData?.today?.punch_in || "-";
     const todayPunchOut = attendanceData?.today?.punch_out || "-";

     return (
          <div style={{ padding: 24, backgroundColor: '#f7f9fc', minHeight: '100vh' }}>
               <div style={{ maxWidth: 1100, margin: '0 auto' }}>

                    <Row style={{ marginBottom: 16 }}>
                         <Col md={8}>
                              <Card>
                                   <Card.Body>
                                        <h5 style={{ marginBottom: 8 }}>Team Snapshot</h5>
                                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                                             <div>
                                                  <div style={{ fontSize: 13, color: '#666' }}>Pending Approvals</div>
                                                  <div style={{ fontSize: 18, fontWeight: 700 }}>—</div>
                                             </div>
                                             <div>
                                                  <div style={{ fontSize: 13, color: '#666' }}>Team On Leave</div>
                                                  <div style={{ fontSize: 18, fontWeight: 700 }}>—</div>
                                             </div>
                                             <div style={{ marginLeft: 'auto' }}>
                                                  <Button size="sm" onClick={() => (window.location.href = '/team/overview')}>View Team</Button>
                                             </div>
                                        </div>
                                   </Card.Body>
                              </Card>
                         </Col>

                         <Col md={4}>
                              <AttendanceCard
                                   title="Today's Attendance"
                                   present={todayPunchIn}
                                   absent={todayPunchOut}
                              />
                         </Col>
                    </Row>

                    <Card>
                         <Card.Body style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                              <Button size="sm" onClick={() => (window.location.href = '/leaves/requests')}>Approve Leaves</Button>
                              <Button size="sm" onClick={() => (window.location.href = '/reports')}>Reports</Button>
                              <Button size="sm" onClick={() => (window.location.href = '/team/attendance')}>Team Attendance</Button>
                         </Card.Body>
                    </Card>
               </div>
          </div>
     );
};

export default BM_Dashboard;